/**
 * DOM Delegate
 */
! function(t) {
  if ("object" == typeof exports && "undefined" != typeof module) module.exports = t();
  else if ("function" == typeof define && define.amd) define([], t);
  else {
    var e;
    e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : this, e.domDelegate = t()
  }
}(function() {
  return function t(e, i, n) {
    function r(o, a) {
      if (!i[o]) {
        if (!e[o]) {
          var l = "function" == typeof require && require;
          if (!a && l) return l(o, !0);
          if (s) return s(o, !0);
          var h = new Error("Cannot find module '" + o + "'");
          throw h.code = "MODULE_NOT_FOUND", h
        }
        var c = i[o] = {
          exports: {}
        };
        e[o][0].call(c.exports, function(t) {
          var i = e[o][1][t];
          return r(i ? i : t)
        }, c, c.exports, t, e, i, n)
      }
      return i[o].exports
    }
    for (var s = "function" == typeof require && require, o = 0; o < n.length; o++) r(n[o]);
    return r
  }({
    1: [function(t, e, i) {
      "use strict";

      function n(t) {
        this.listenerMap = [{}, {}], t && this.root(t), this.handle = n.prototype.handle.bind(this)
      }

      function r(t, e) {
        return t.toLowerCase() === e.tagName.toLowerCase()
      }

      function s(t, e) {
        return this.rootElement === window ? e === document : this.rootElement === e
      }

      function o(t, e) {
        return t === e.id
      }
      e.exports = n, n.prototype.root = function(t) {
        var e, i = this.listenerMap;
        if (this.rootElement) {
          for (e in i[1]) i[1].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !0);
          for (e in i[0]) i[0].hasOwnProperty(e) && this.rootElement.removeEventListener(e, this.handle, !1)
        }
        if (!t || !t.addEventListener) return this.rootElement && delete this.rootElement, this;
        this.rootElement = t;
        for (e in i[1]) i[1].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !0);
        for (e in i[0]) i[0].hasOwnProperty(e) && this.rootElement.addEventListener(e, this.handle, !1);
        return this
      }, n.prototype.captureForType = function(t) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(t) !== -1
      }, n.prototype.on = function(t, e, i, n) {
        var l, h, c, u;
        if (!t) throw new TypeError("Invalid event type: " + t);
        if ("function" == typeof e && (n = i, i = e, e = null), void 0 === n && (n = this.captureForType(t)), "function" != typeof i) throw new TypeError("Handler must be a type of Function");
        return l = this.rootElement, h = this.listenerMap[n ? 1 : 0], h[t] || (l && l.addEventListener(t, this.handle, n), h[t] = []), e ? /^[a-z]+$/i.test(e) ? (u = e, c = r) : /^#[a-z0-9\-_]+$/i.test(e) ? (u = e.slice(1), c = o) : (u = e, c = a) : (u = null, c = s.bind(this)), h[t].push({
          selector: e,
          handler: i,
          matcher: c,
          matcherParam: u
        }), this
      }, n.prototype.off = function(t, e, i, n) {
        var r, s, o, a, l;
        if ("function" == typeof e && (n = i, i = e, e = null), void 0 === n) return this.off(t, e, i, !0), this.off(t, e, i, !1), this;
        if (o = this.listenerMap[n ? 1 : 0], !t) {
          for (l in o) o.hasOwnProperty(l) && this.off(l, e, i);
          return this
        }
        if (a = o[t], !a || !a.length) return this;
        for (r = a.length - 1; r >= 0; r--) s = a[r], e && e !== s.selector || i && i !== s.handler || a.splice(r, 1);
        return a.length || (delete o[t], this.rootElement && this.rootElement.removeEventListener(t, this.handle, n)), this
      }, n.prototype.handle = function(t) {
        var e, i, n, r, s, o, a, l = t.type,
          h = [],
          c = "ftLabsDelegateIgnore";
        if (t[c] !== !0) {
          switch (a = t.target, 3 === a.nodeType && (a = a.parentNode), n = this.rootElement, r = t.eventPhase || (t.target !== t.currentTarget ? 3 : 2)) {
            case 1:
              h = this.listenerMap[1][l];
              break;
            case 2:
              this.listenerMap[0] && this.listenerMap[0][l] && (h = h.concat(this.listenerMap[0][l])), this.listenerMap[1] && this.listenerMap[1][l] && (h = h.concat(this.listenerMap[1][l]));
              break;
            case 3:
              h = this.listenerMap[0][l]
          }
          for (i = h.length; a && i;) {
            for (e = 0; e < i && (s = h[e]); e++)
              if (s.matcher.call(a, s.matcherParam, a) && (o = this.fire(t, a, s)), o === !1) return t[c] = !0, void t.preventDefault();
            if (a === n) break;
            i = h.length, a = a.parentElement
          }
        }
      }, n.prototype.fire = function(t, e, i) {
        return i.handler.call(e, t, e)
      };
      var a = function(t) {
        if (t) {
          var e = t.prototype;
          return e.matches || e.matchesSelector || e.webkitMatchesSelector || e.mozMatchesSelector || e.msMatchesSelector || e.oMatchesSelector
        }
      }(Element);
      n.prototype.destroy = function() {
        this.off(), this.root()
      }
    }, {}],
    2: [function(t, e, i) {
      "use strict";
      var n = t("./delegate");
      e.exports = function(t) {
        return new n(t)
      }, e.exports.Delegate = n
    }, {
      "./delegate": 1
    }]
  }, {}, [2])(2)
});

/**
 * Fast DOM
 */
! function(t) {
  "use strict";

  function e() {
    var e = this;
    e.reads = [], e.writes = [], e.raf = l.bind(t), a("initialized", e)
  }

  function i(t) {
    t.scheduled || (t.scheduled = !0, t.raf(n.bind(null, t)), a("flush scheduled"))
  }

  function n(t) {
    a("flush");
    var e, n = t.writes,
      s = t.reads;
    try {
      a("flushing reads", s.length), r(s), a("flushing writes", n.length), r(n)
    } catch (o) {
      e = o
    }
    if (t.scheduled = !1, (s.length || n.length) && i(t), e) {
      if (a("task errored", e.message), !t["catch"]) throw e;
      t["catch"](e)
    }
  }

  function r(t) {
    a("run tasks");
    for (var e; e = t.shift();) e()
  }

  function s(t, e) {
    var i = t.indexOf(e);
    return !!~i && !!t.splice(i, 1)
  }

  function o(t, e) {
    for (var i in e) e.hasOwnProperty(i) && (t[i] = e[i])
  }
  var a = function() {},
    l = t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.msRequestAnimationFrame || function(t) {
      return setTimeout(t, 16)
    };
  e.prototype = {
    constructor: e,
    measure: function(t, e) {
      a("measure");
      var n = e ? t.bind(e) : t;
      return this.reads.push(n), i(this), n
    },
    mutate: function(t, e) {
      a("mutate");
      var n = e ? t.bind(e) : t;
      return this.writes.push(n), i(this), n
    },
    clear: function(t) {
      return a("clear", t), s(this.reads, t) || s(this.writes, t)
    },
    extend: function(t) {
      if (a("extend", t), "object" != typeof t) throw new Error("expected object");
      var e = Object.create(this);
      return o(e, t), e.fastdom = this, e.initialize && e.initialize(), e
    },
    "catch": null
  };
  var h = t.fastdom = t.fastdom || new e;
  "function" == typeof define ? define(function() {
    return h
  }) : "object" == typeof module && (module.exports = h)
}("undefined" != typeof window ? window : this),

/**
 * Polyfills for smooth scrolling in: scrollIntoView, scroll, scrollBy
 */
function() {
  "use strict";

  function t(t) {
    var e = ["MSIE ", "Trident/", "Edge/"];
    return new RegExp(e.join("|")).test(t)
  }

  function e() {
    function e(t, e) {
      this.scrollLeft = t, this.scrollTop = e
    }

    function r(t) {
      return .5 * (1 - Math.cos(Math.PI * t))
    }

    function s(t) {
      if (null === t || "object" != typeof t || void 0 === t.behavior || "auto" === t.behavior || "instant" === t.behavior) return !0;
      if ("object" == typeof t && "smooth" === t.behavior) return !1;
      throw new TypeError("behavior member of ScrollOptions " + t.behavior + " is not a valid value for enumeration ScrollBehavior.")
    }

    function o(t, e) {
      return "Y" === e ? t.clientHeight + p < t.scrollHeight : "X" === e ? t.clientWidth + p < t.scrollWidth : void 0
    }

    function a(t, e) {
      var n = i.getComputedStyle(t, null)["overflow" + e];
      return "auto" === n || "scroll" === n
    }

    function l(t) {
      var e = o(t, "Y") && a(t, "Y"),
        i = o(t, "X") && a(t, "X");
      return e || i
    }

    function h(t) {
      var e;
      do t = t.parentNode, e = t === n.body; while (e === !1 && l(t) === !1);
      return e = null, t
    }

    function c(t) {
      var e, n, s, o = g(),
        a = (o - t.startTime) / d;
      a = a > 1 ? 1 : a, e = r(a), n = t.startX + (t.x - t.startX) * e, s = t.startY + (t.y - t.startY) * e, t.method.call(t.scrollable, n, s), n === t.x && s === t.y || i.requestAnimationFrame(c.bind(i, t))
    }

    function u(t, r, s) {
      var o, a, l, h, u = g();
      t === n.body ? (o = i, a = i.scrollX || i.pageXOffset, l = i.scrollY || i.pageYOffset, h = m.scroll) : (o = t, a = t.scrollLeft, l = t.scrollTop, h = e), c({
        scrollable: o,
        method: h,
        startTime: u,
        startX: a,
        startY: l,
        x: r,
        y: s
      })
    }
    if (!("scrollBehavior" in n.documentElement.style && i.__forceSmoothScrollPolyfill__ !== !0)) {
      var f = i.HTMLElement || i.Element,
        d = 468,
        p = t(i.navigator.userAgent) ? 1 : 0,
        m = {
          scroll: i.scroll || i.scrollTo,
          scrollBy: i.scrollBy,
          elementScroll: f.prototype.scroll || e,
          scrollIntoView: f.prototype.scrollIntoView
        },
        g = i.performance && i.performance.now ? i.performance.now.bind(i.performance) : Date.now;
      i.scroll = i.scrollTo = function() {
        if (void 0 !== arguments[0]) return s(arguments[0]) === !0 ? void m.scroll.call(i, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : i.scrollX || i.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : i.scrollY || i.pageYOffset) : void u.call(i, n.body, void 0 !== arguments[0].left ? ~~arguments[0].left : i.scrollX || i.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : i.scrollY || i.pageYOffset)
      }, i.scrollBy = function() {
        if (void 0 !== arguments[0]) return s(arguments[0]) ? void m.scrollBy.call(i, void 0 !== arguments[0].left ? arguments[0].left : "object" != typeof arguments[0] ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0) : void u.call(i, n.body, ~~arguments[0].left + (i.scrollX || i.pageXOffset), ~~arguments[0].top + (i.scrollY || i.pageYOffset))
      }, f.prototype.scroll = f.prototype.scrollTo = function() {
        if (void 0 !== arguments[0]) {
          if (s(arguments[0]) === !0) {
            if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw new SyntaxError("Value couldn't be converted");
            return void m.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" != typeof arguments[0] ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop)
          }
          var t = arguments[0].left,
            e = arguments[0].top;
          u.call(this, this, "undefined" == typeof t ? this.scrollLeft : ~~t, "undefined" == typeof e ? this.scrollTop : ~~e)
        }
      }, f.prototype.scrollBy = function() {
        if (void 0 !== arguments[0]) return s(arguments[0]) === !0 ? void m.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop) : void this.scroll({
          left: ~~arguments[0].left + this.scrollLeft,
          top: ~~arguments[0].top + this.scrollTop,
          behavior: arguments[0].behavior
        })
      }, f.prototype.scrollIntoView = function() {
        if (s(arguments[0]) === !0) return void m.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0]);
        var t = h(this),
          e = t.getBoundingClientRect(),
          r = this.getBoundingClientRect();
        t !== n.body ? (u.call(this, t, t.scrollLeft + r.left - e.left, t.scrollTop + r.top - e.top), "fixed" !== i.getComputedStyle(t).position && i.scrollBy({
          left: e.left,
          top: e.top,
          behavior: "smooth"
        })) : i.scrollBy({
          left: r.left,
          top: r.top,
          behavior: "smooth"
        })
      }
    }
  }
  var i = window,
    n = document;
  "object" == typeof exports ? module.exports = {
    polyfill: e
  } : e()
}(),

/**
 * VM Slider v0.3.1
 * Options:
 * - controls: true|false (Enable prev/next buttons, default: true)
 * - nav: true|false (Enable navigation, default: true)
 * - drag: true|false (Enable drag, default: true)
 * - autoplay: true|false (Enable autoplay, default: false)
 * - autoplayInterval: number (Autoplay interval in milliseconds, default: 5000)
 * - height: 'current'|'max' (Height of slider, default: 'max')
 * - onSlideEnter: function (Callback when slide enters viewport)
 * - onSlideLeave: function (Callback when slide leaves viewport)
 * - enable: true|false (Enable slider, default: true)
 * - dragChangeMin: number (Minimum horizontal drag distance to change slide, default: 20)
 * - overdrag: number (Overdrag in pixels, default: 400)
 * - transitionTime: number (Maximum time in seconds for slide transition, default: 0.6)
 * - dragMomentum: number (Momentum threshold in pixels per millisecond after which additional slides are scrolled, default: 7)
 * - momentumTime: number (Time in milliseconds after which momentum is reset, default: 150)
 * - mouseMomentumFactor: number (Factor to increase momentum for mouse events, default: 3)
 * - useMomentum: true|false (Use momentum for slide selection after dragging, default: true)
 * - watchCSS: true|false (Disable slider if CSS content property is set to enable, default: false)
 * - spacing: 'auto'|'none' (Spacing between slides, default: 'none')
 * - align: 'start'|'center' (Alignment of slides, default: 'start')
 */

(function () {

  class Slider {

    /**
     * Creates a new slider instance and does initial setup
     * @param {Element} element Slider element, needs to have .Slider class
     * @param {{"controls":boolean|undefined;"nav":boolean|undefined;drag:boolean|undefined;"autoplay":boolean|undefined;"autoplayInterval":number|undefined;"height":"current"|"max"|undefined;"onSlideEnter":function|undefined;"onSlideLeave":function|undefined;"enable":boolean;"dragChangeMin":number|undefined;"overdrag":number|undefined;"transitionTime":number|undefined;"dragMomentum":number|undefined;"momentumTime":number|undefined;"mouseMomentumFactor":number|undefined;"useMomentum":boolean|undefined,"watchCSS":boolean|undefined,"spacing":"auto"|"none"|undefined;"align":"start"|"center"|undefined}} options Slider options
     */
    constructor(element, options = {}) {
      const t = this;
      t.element = element;
      t.viewport = element.querySelector('.Slider__Viewport');
      t.contentContainer = element.querySelector('.Slider__Content');
      t.controlsContainer = element.querySelector('.Slider__Controls');
      t.nav = element.querySelector('.Slider__Nav');
      // Create config with default values that can be overwritten by data config and programmatic options
      t.config = {
        drag: true,
        autoplayInterval: 5000,
        enable: true,
        height: 'max',
        dragChangeMin: 20,
        overdrag: 400,
        transitionTime: 0.6,
        dragMomentum: 8,
        momentumTime: 150,
        mouseMomentumFactor: 3,
        useMomentum: true,
        spacing: 'none',
        align: 'start',
        ...JSON.parse(element.getAttribute('data-config') || '{}'),
        ...options
      };
      t.config.controls = t.config.controls !== false && t.controlsContainer;
      t.config.nav = t.config.nav !== false && t.nav;
      if (t.config.controls) {
        t.prevButton = t.controlsContainer.querySelector('.Slider__Control--prev');
        t.nextButton = t.controlsContainer.querySelector('.Slider__Control--next');
      }
      t.currentIndex = null;
      t.enabled = false;
      t.hasInteraction = false;
      t.lastWidth = 0;
      t.lastCellWidth = 0;
      t.draggingX = false;
      t.draggingY = false;
      t.dragDelta = 0;
      t.offset = 0;
      t.onPrev = e => {
        t.stopAutoplay();
        t.prev();
      }
      t.onNext = e => {
        t.stopAutoplay();
        t.next();
      }
      t.onDragStart = t.dragStart.bind(t);
      t.onDrag = t.drag.bind(t);
      t.onDragEnd = t.dragEnd.bind(t);
      t.onKeyDown = t.keyDown.bind(t);
      t.onFocusIn = t.focusIn.bind(t);
      t.onStopAutoplay = t.stopAutoplay.bind(t);
      t.onNativeDrag = e => e.preventDefault();
      t.onTransition = e => {
        if (e.propertyName === 'transform') t.isTransitioning = e.type === 'transitionstart';
      };
      t.resizeTimeout = null;
      // If slides can be disabled with CSS, setup listener to reenable slider when it is disabled
      if (t.config.watchCSS) {
        t.checkCSS = () => {
          clearTimeout(t.cssTimeout);
          t.cssTimeout = setTimeout(() => {
            t.cssTimeout = null;
            if (t.isCSSEnabled()) {
              t.cssEnabled = true;
              t.enable();
              window.removeEventListener('resize', t.onCSSChange);
            }
          }, 100);
        };
        t.onCSSChange = t.checkCSS.bind(t);
      }
      t.onResize = () => {
        clearTimeout(t.resizeTimeout);
        t.resizeTimeout = setTimeout(() => {
          t.resizeTimeout = null;
          if (!t.isCSSEnabled()) {
            t.cssEnabled = false;
            t.disable();
            window.addEventListener('resize', t.onCSSChange);
            return;
          }
          requestAnimationFrame(() => {
            // Only do resize calculations if the width has changed, the height does not matter. That also prevents resizing when resize is fired due to address bar appearing/disappearing on mobile.
            const width = t.element.getBoundingClientRect().width,
                  cellWidth = t.slides.length > 0 ? t.slides[0].getBoundingClientRect().width : 0;
            if (t.lastWidth === width && t.lastCellWidth === cellWidth) return;
            element.classList.add('is-resizing');
            t.lastWidth = width;
            t.lastCellWidth = cellWidth;
            t.resize();
            element.classList.remove('is-resizing');
          });
        }, 100);
      };
      t.onVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
          t.autoplay();
        }
        else {
          t.stopAutoplay();
        }
      };
      t.cssEnabled = t.isCSSEnabled();
      t.slides = Array.from(element.querySelectorAll('.Slider__Slide'));
      t.element.style.setProperty('--slider-autoplay-interval', `${t.config.autoplayInterval}ms`);
      if (t.config.enable && t.cssEnabled) {
        t.enabled = true;
        t.init();
        t.addListeners();
        t.autoplay();
        t.slides.forEach(slide => t.toggleSlideFocusability(slide, false));
      }
      if (!t.cssEnabled) window.addEventListener('resize', t.onCSSChange);
    }

    /**
     * Repaint and init slider after changes
     */
    init() {
      this.currentIndex = null;
      this.element.classList.remove('is-initialized');
      this.element.style.setProperty('--slider-offset', `0px`);
      requestAnimationFrame(this.resize.bind(this));
    }

    /**
     * Add slide at a given index or at the end
     * @param {Element} slide Slide element
     * @param {number|undefined} index Index of slide, slide is added at the end if not provided
     * @returns true if slide was added, false if index is out of bounds
     */
    addSlide(slide, index) {
      const t = this;
      let slides = t.slides;
      if (index !== undefined && (index < 0 || index > slides.length)) return false;
      t.toggleSlideFocusability(slide, false);
      const indexFixed = index !== undefined ? index : slides.length,
            contentContainer = t.contentContainer;
      if (indexFixed === slides.length) {
        if (contentContainer.firstElementChild) {
          contentContainer.insertBefore(slide, contentContainer.firstElementChild);
        }
        else {
          contentContainer.appendChild(slide);
        }
        slides.push(slide);
      }
      else {
        contentContainer.insertBefore(slide, slides[indexFixed]);
        t.slides = [
          ...slides.slice(0, indexFixed),
          slide,
          ...slides.slice(indexFixed)
        ];
        slides = t.slides;
      }
      return true;
    }

    /**
     * Remove a slide
     * @param {Element} slide Slide to remove
     * @returns true if slide was removed, false if slide was not present
     */
    removeSlide(slide) {
      const index = this.slides.indexOf(slide);
      if (index === -1) return false;
      slide.remove();
      this.slides.splice(index, 1);
      return true;
    }

    /**
     * Toggles focusability of all focusable elements in the slide
     * @param {Element} slide Slide to toggle focusability for
     * @param {boolean} allowed True if slide should be focusable, false if not
     * @param {boolean} includeAllVisible True if all visible slides should be included, default is false
     */
    toggleSlideFocusability(slide, allowed) {
      slide.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      slide.querySelectorAll('a, button, input, textarea, select').forEach(el => {
        if (allowed) {
          el.removeAttribute('tabindex');
        }
        else {
          el.setAttribute('tabindex', '-1');
        }
      });
    }

    /**
     * Disable slider by removing listeners and stopping autoplay
     */
    disable() {
      const t = this;
      t.enabled = false;
      t.element.classList.remove('is-initialized');
      t.slides.forEach(slide => t.toggleSlideFocusability(slide, true));
      t.removeListeners();
      t.stopAutoplay();
    }

    /**
     * Enable slider by adding listeners and starting autoplay
     */
    enable() {
      const t = this;
      t.enabled = true;
      t.cssEnabled = t.isCSSEnabled();
      if (!t.cssEnabled) return;
      t.addListeners();
      requestAnimationFrame(() => {
        t.slides.forEach(slide => t.toggleSlideFocusability(slide, false));
        t.resize();
        t.autoplay();
      });
    }

    /**
     * Checks if slider is not disabled via CSS
     * @returns {boolean} True if slider is not disabled via CSS
     */
    isCSSEnabled() {
      if (!this.config.watchCSS) return true;
      const pseudoStyle = window.getComputedStyle(this.element, ':after');
      return pseudoStyle && pseudoStyle.content.includes('slider');
    }

    /**
     * Fit slider to current window size
     */
    resize() {
      const t = this,
            slides = t.slides;
      t.viewportWidth = t.viewport.getBoundingClientRect().width;
      if (t.config.nav) t.navWidth = t.nav.getBoundingClientRect().width;
      const slideRects = Array.from(slides).map(slide => slide.getBoundingClientRect());

      // Determine number of visible slides and total cell width
      t.visibleSlideCount = 0;
      t.maxVisibleSlideCount = 0;
      t.contentWidth = 0;
      let maxVisibleSlideWidth = 0;
      for (let index = 0; index < slides.length; index++) {
        const slideWidth = slideRects[index].width;
        t.contentWidth += slideWidth;
        if (index == 0 || t.contentWidth <= t.viewportWidth) {
          t.visibleSlideCount++;
          maxVisibleSlideWidth += slideWidth;
        }
      }
      t.visibleSlideCount = Math.max(1, t.visibleSlideCount);
      t.maxVisibleSlideCount = t.visibleSlideCount;
      if (slides.length > 0 && maxVisibleSlideWidth < t.viewportWidth) {
        while (maxVisibleSlideWidth + slideRects[0].width <= t.viewportWidth) {
          t.maxVisibleSlideCount++;
          maxVisibleSlideWidth += slideRects[0].width;
        }
      }
      t.slideStartOffset = t.config.spacing === 'auto' ? Math.max(0, (t.viewportWidth - maxVisibleSlideWidth) / (t.maxVisibleSlideCount + 1)) : 0;
      t.contentWidth += t.slideStartOffset * (slides.length + 1);

      // Set slide start positions and determine visible slides
      let currentWidth = t.slideStartOffset;
      let maxHeight = 0;
      slides.forEach((slide, index) => {
        slide.style.setProperty('--slide-start', `${Math.round(currentWidth)}px`);
        currentWidth += slideRects[index].width + t.slideStartOffset;
        if (index < t.visibleSlideCount) {
          slide.classList.add('is-selected');
        }
        else {
          slide.classList.remove('is-selected');
        }
        maxHeight = Math.max(maxHeight, slideRects[index].height);
      });
      t.select(Math.min(t.currentIndex, slides.length - t.visibleSlideCount));

      if (t.config.drag) {
        t.isDraggable = slides.length > t.visibleSlideCount;
        t.element.classList.toggle('is-draggable', t.isDraggable);
      }
      if (t.config.controls) t.controlsContainer.classList.toggle('is-hidden', t.visibleSlideCount >= slides.length);
      t.element.style.setProperty('--slider-height', `${t.config.height === 'current' ? slideRects[t.currentIndex].height : maxHeight}px`);
      if (t.config.nav) t.nav.style.setProperty('--nav-width', `${t.viewportWidth / t.contentWidth * 100}%`);
      if (t.enabled) t.element.classList.add('is-initialized');
    }

    /**
     * Create event listeners for slider depending on config
     */
    addListeners() {
      const t = this;
      if (t.config.controls) {
        t.prevButton.addEventListener('click', t.onPrev);
        t.nextButton.addEventListener('click', t.onNext);
      }
      if (t.config.drag) {
        t.viewport.addEventListener('mousedown', t.onDragStart, { passive: true });
        t.viewport.addEventListener('touchstart', t.onDragStart, { passive: true });
      }
      if (t.config.autoplay && t.config.controls) {
        t.prevButton.addEventListener('click', t.onStopAutoplay, { once: true });
        t.nextButton.addEventListener('click', t.onStopAutoplay, { once: true });
      }
      t.element.addEventListener('keydown', t.onKeyDown);
      t.element.addEventListener('focusin', t.onFocusIn);
      t.viewport.addEventListener('dragstart', t.onNativeDrag);
      t.contentContainer.addEventListener('transitionstart', t.onTransition);
      t.contentContainer.addEventListener('transitionend', t.onTransition);
      document.addEventListener('visibilitychange', t.onVisibilityChange);
      window.addEventListener('resize', t.onResize);
    }

    /**
     * Remove all event listeners
     */
    removeListeners() {
      const t = this;
      t.viewport.removeEventListener('mousedown', t.onDragStart);
      t.viewport.removeEventListener('touchstart', t.onDragStart);
      t.viewport.removeEventListener('dragstart', t.onNativeDrag);
      if (t.config.controls) {
        t.prevButton.removeEventListener('click', t.onPrev);
        t.nextButton.removeEventListener('click', t.onNext);
        t.prevButton.removeEventListener('click', t.onStopAutoplay);
        t.nextButton.removeEventListener('click', t.onStopAutoplay);
      }
      t.contentContainer.removeEventListener('transitionstart', t.onTransition);
      t.contentContainer.removeEventListener('transitionend', t.onTransition);
      document.removeEventListener('visibilitychange', t.onVisibilityChange);
      window.removeEventListener('resize', t.onResize);
    }

    /**
     * Select previous slide if possible
     */
    prev() {
      if (this.currentIndex === 0) return;
      this.element.style.setProperty('--slider-drag-speed', 0.5);
      this.element.style.setProperty('--slider-transition-time', 0.8);
      this.select(Math.max(0, this.currentIndex - this.visibleSlideCount));
    }

    /**
     * Select next slide if possible
     */
    next() {
      if (this.currentIndex + this.visibleSlideCount >= this.slides.length) return;
      this.element.style.setProperty('--slider-drag-speed', 0.5);
      this.element.style.setProperty('--slider-transition-time', 0.8);
      this.select(this.currentIndex + this.visibleSlideCount);
    }

    /**
     * Select slide by index
     * @param {number} index Index of slide to select
     */
    select(index) {
      const t = this,
            slides = t.slides;
      if (index === null) index = slides.length > 0 ? 0 : null;
      if (index === null || index < 0 || index >= slides.length) return;
      if (t.config.onSlideLeave && t.currentIndex !== null) t.config.onSlideLeave(slides[t.currentIndex]);
      if (t.currentIndex !== null) {
        const currentIndexFixed = t.visibleSlideCount > 1 && t.currentIndex + t.visibleSlideCount > slides.length ? slides.length - t.visibleSlideCount : t.currentIndex;
        for (let i = currentIndexFixed; i < Math.min(currentIndexFixed + t.visibleSlideCount, slides.length); i++) {
          t.toggleSlideFocusability(slides[i], false);
        }
      }
      const indexFixed = t.visibleSlideCount > 1 && index + t.visibleSlideCount > slides.length ? slides.length - t.visibleSlideCount : index,
            currentRect = slides[indexFixed].getBoundingClientRect(),
            currentHeight = t.config.height === 'current' ? currentRect.height : 0;
      if (t.config.onSlideEnter) t.config.onSlideEnter(slides[indexFixed]);
      // Get offset of selected slide and modify it depending on the align setting
      const newOffset = parseInt(slides[indexFixed].style.getPropertyValue('--slide-start').replace(/[^\d]/g, '')) - (t.config.align === 'center' ? (t.viewportWidth - currentRect.width * t.visibleSlideCount) / 2 : 0);
      // Set new offset keeping it in the bounds
      t.offset = t.contentWidth >= t.viewportWidth ? Math.min(0, Math.max(t.viewportWidth - t.contentWidth, (newOffset - t.slideStartOffset) * -1)) : t.config.align === 'center' ? (t.viewportWidth - t.contentWidth) / 2 : 0;
      t.element.style.setProperty('--slider-offset', `${Math.round(t.offset)}px`);
      if (t.config.height === 'current') t.element.style.setProperty('--slider-height', `${currentHeight}px`);
      t.currentIndex = index;
      t.updateControls();
      t.updateNav();
      for (let i = indexFixed; i < Math.min(indexFixed + t.visibleSlideCount, slides.length); i++) {
        t.toggleSlideFocusability(slides[i], true);
      }
      if (!t.hasInteraction && index !== 0) t.hasInteraction = true;
      if (t.hasInteraction) {
        t.element.dispatchEvent(new CustomEvent('theme:slider:slidechanged', { detail: { index, slide: t.slides[index], totalSlides: t.slides.length } }));
      }
    }

    /**
     * Prepare for dragging
     * @param {MouseEvent|TouchEvent} e Mouse click or touch start event
     */
    dragStart(e) {
      const t = this;
      if (!t.isDraggable || e.target.classList.contains('Slider__Control') || e.target.closest('.Slider__Control')) return;
      t.draggingX = 0;
      t.draggingY = 0;
      t.lastDrag = performance.now();
      t.dragTime = 0;
      t.momentum = 0;
      if (window.TouchEvent && e instanceof TouchEvent) {
        t.dragTouchX = e.touches[0].clientX;
        t.dragTouchY = e.touches[0].clientY;
      }
      const documentElement = document.documentElement;
      documentElement.addEventListener('mouseup', t.onDragEnd);
      documentElement.addEventListener('mousemove', t.onDrag, { passive: true });
      documentElement.addEventListener('touchend', t.onDragEnd);
      documentElement.addEventListener('touchcancel', t.onDragEnd);
      documentElement.addEventListener('touchmove', t.onDrag, { passive: true });
    }

    /**
     * Drag slider if threshold is reached
     * @param {MouseEvent|TouchEvent} e Mouse move or touch move event
     */
    drag(e) {
      const t = this;
      if (t.draggingX === false) return;

      // Determine pixel movement
      let movementX, movementY;
      if (e.type === 'touchmove') {
        movementX = e.touches[0].clientX - t.dragTouchX;
        movementY = e.touches[0].clientY - t.dragTouchY;
        t.dragTouchX = e.touches[0].clientX;
        t.dragTouchY = e.touches[0].clientY;
      }
      else {
        movementX = e.movementX;
        movementY = e.movementY;
      }

      // If dragging is below threshold, check if threshold is reached or prevent slider dragging if vertical dragging is more likely to be intended
      if (t.draggingX !== true) {
        t.draggingX += movementX;
        t.draggingY += movementY;
        const absX = Math.abs(t.draggingX),
              absY = Math.abs(t.draggingY);
        if (absX > absY) {
          t.draggingX = true;
          if (t.isTransitioning) {
            // Parse current transform offset when transition is running to prevent jump
            const transform = getComputedStyle(t.contentContainer).transform,
                  transformOffsetX = parseFloat(transform && transform.match(/^([^,]*,){5}[^,]*$/) ? transform.split(/,/g)[4] : t.offset);
            t.offset = transformOffsetX;
          }
          t.element.classList.add('is-dragging');
          t.animate();
          t.stopAutoplay();
        }
        else if (absX < absY - 1) {
          t.draggingX = false;
          t.draggingY = true;
          return;
        }
        else {
          return;
        }
      }

      // Update drag delta and direction, calculate momentum if enabled
      t.dragDelta += movementX;
      if (movementX !== 0) t.dragDirection = movementX > 0 ? -1 : 1;
      const now = performance.now(),
            timeDelta = Math.min(t.config.momentumTime, now - t.lastDrag);
      if (t.dragTime + timeDelta > t.config.momentumTime) t.dragTime -= timeDelta;
      t.dragTime += timeDelta;
      t.momentum = (t.dragTime * t.momentum + timeDelta * Math.abs(movementX)) / (t.dragTime + timeDelta);
      t.lastDrag = now;

      // Overdrag with linear slowdown if slider is at the end
      if (t.offset > 0 || t.offset < t.viewportWidth - t.contentWidth) {
        t.offset += movementX * ((-1 / t.config.overdrag) * Math.abs(t.offset - (t.offset > 0 ? 0 : t.viewportWidth - t.contentWidth)) + 1);
      }
      else {
        t.offset += movementX;
      }
    }

    /**
     * End dragging and select slide depending on drag direction and delta
     */
    dragEnd(e) {
      const t = this;
      if (t.draggingX === false) return;

      if (t.draggingX === true) {
        t.draggingX = false;
        // Select the nearest slide considering the current scroll delta, direction and momentum
        const scrolledSlides = Math.ceil(Math.abs(t.dragDelta) / t.contentWidth * t.slides.length / t.visibleSlideCount) + (t.config.useMomentum ? Math.floor(t.momentum / (t.config.dragMomentum * (e.type === 'touchend' ? 1 : t.config.mouseMomentumFactor))) : 0),
              slideWidth = t.contentWidth / t.slides.length,
              dragSpeed = Math.min(1, (t.momentum + 5) / 40),
              transitionTime = Math.min(1, (slideWidth * t.visibleSlideCount - ((Math.abs(t.dragDelta) - t.config.dragChangeMin) % slideWidth) + (scrolledSlides - 1) * slideWidth) / t.viewportWidth);
        t.element.style.setProperty('--slider-drag-speed', dragSpeed);
        t.element.style.setProperty('--slider-transition-time', transitionTime);
        t.element.classList.remove('is-dragging');
        if (t.dragDelta < t.config.dragChangeMin * -1 && t.currentIndex + t.visibleSlideCount < t.slides.length) {
          t.select(Math.min(t.slides.length - 1, t.currentIndex + t.visibleSlideCount * (scrolledSlides - (t.dragDirection === 1 ? 0 : 1))));
        }
        else if (t.dragDelta > t.config.dragChangeMin) {
          t.select(Math.max(0, t.currentIndex - t.visibleSlideCount * (scrolledSlides - (t.dragDirection === -1 ? 0 : 1))));
        }
        else {
          t.select(t.currentIndex);
        }
        e.preventDefault();
      }

      t.dragDelta = 0;
      t.dragDirection = 0;
      t.momentum = 0;
      t.dragTime = 0;
      const documentElement = document.documentElement;
      documentElement.removeEventListener('mouseup', t.onDragEnd);
      documentElement.removeEventListener('mouseleave', t.onDragEnd);
      documentElement.removeEventListener('mousemove', t.onDrag);
      documentElement.removeEventListener('touchend', t.onDragEnd);
      documentElement.removeEventListener('touchcancel', t.onDragEnd);
      documentElement.removeEventListener('touchmove', t.onDrag);
    }

    /**
     * Handle keyboard events (a11y)
     */
    keyDown(e) {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prev();
      }
      else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.next();
      }
    }

    /**
     * Handle focusin events (a11y)
     */
    focusIn() {
      if (this.config.autoplay) this.stopAutoplay();
    }

    /**
     * Set visibility of prev/next buttons depending on current slide
     */
    updateControls() {
      const t = this;
      if (!t.config.controls) return;
      if (Math.min(t.currentIndex, t.slides.length - t.visibleSlideCount) === 0) {
        t.prevButton.setAttribute('aria-disabled', 'true');
      }
      else {
        t.prevButton.setAttribute('aria-disabled', 'false');
      }
      if (t.currentIndex + t.visibleSlideCount >= t.slides.length) {
        t.nextButton.setAttribute('aria-disabled', 'true');
      }
      else {
        t.nextButton.setAttribute('aria-disabled', 'false');
      }
    }

    /**
     * Update navigation bar position depending on current slide
     */
    updateNav() {
      const t = this;
      if (!t.nav) return;
      if (!t.config.nav || t.visibleSlideCount >= t.slides.length) {
        t.nav.classList.add('is-hidden');
        return;
      }
      t.nav.classList.remove('is-hidden');
      t.nav.style.setProperty('--nav-start', `${Math.round(t.offset * -1 / t.contentWidth * t.navWidth)}px`);
    }

    /**
     * Update slider position while dragging in new frame
     */
    animate() {
      const t = this;
      if (t.draggingX === false) return;
      requestAnimationFrame(() => {
        if (t.draggingX === false) return;
        t.element.style.setProperty('--slider-offset', `${Math.round(t.offset)}px`);
        t.updateNav();
        t.animate();
      });
    }

    /**
     * Start autoplay if enabled
     */
    autoplay() {
      const t = this;
      if (!t.enabled || !t.config.autoplay || t.slides.length <= 1) return;
      t.element.classList.add('is-autoplaying');
      t.contentContainer.setAttribute('aria-live', 'off');
      t.autoplayInterval = setInterval(() => {
        t.element.classList.remove('is-autoplaying');
        if (t.visibleSlideCount >= t.slides.length) return;
        if (t.currentIndex + t.visibleSlideCount >= t.slides.length) {
          t.select(0);
        }
        else {
          t.next();
        }
        t.element.classList.add('is-autoplaying');
      }, t.config.autoplayInterval);
    }

    /**
     * Stop autoplay
     */
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.element.classList.remove('is-autoplaying');
        this.contentContainer.setAttribute('aria-live', 'polite');
      }
    }
  }

  window.Slider = Slider;

})();

/**
 * Mini Masonry
 * https://github.com/Spope/MiniMasonry.js/
 */
(function () {
  var MiniMasonry = function(conf) {
    this._sizes             = [];
    this._columns           = [];
    this._container         = null;
    this._count             = null;
    this._width             = 0;
    this._removeListener    = null;
    this._currentGutterX    = null;
    this._currentGutterY    = null;

    this._resizeTimeout = null,

    this.conf = {
        baseWidth: 255,
        gutterX: null,
        gutterY: null,
        gutter: 10,
        container: null,
        minify: true,
        ultimateGutter: 5,
        surroundingGutter: true,
        direction: 'ltr',
        wedge: false
    };

    this.init(conf);

    return this;
  };

  MiniMasonry.prototype.init = function(conf) {
      for (var i in this.conf) {
          if (conf[i] != undefined) {
              this.conf[i] = conf[i];
          }
      }

      if (this.conf.gutterX == null || this.conf.gutterY == null) {
          this.conf.gutterX = this.conf.gutterY = this.conf.gutter;
      }
      this._currentGutterX = this.conf.gutterX;
      this._currentGutterY = this.conf.gutterY;

      this._container = typeof this.conf.container == 'object' && this.conf.container.nodeName ?
          this.conf.container :
          document.querySelector(this.conf.container);

      if (!this._container) {
          throw new Error('Container not found or missing');
      }

      var onResize = this.resizeThrottler.bind(this);
      window.addEventListener("resize", onResize);
      this._removeListener = function() {
          window.removeEventListener("resize", onResize);
          if (this._resizeTimeout != null) {
              window.clearTimeout(this._resizeTimeout);
              this._resizeTimeout = null;
          }
      };

      this.layout();
  };

  MiniMasonry.prototype.reset = function() {
      this._sizes   = [];
      this._columns = [];
      this._count   = null;
      this._width   = this._container.clientWidth;
      var minWidth  = this.conf.baseWidth;
      if (this._width < minWidth) {
          this._width = minWidth;
          this._container.style.minWidth = minWidth + 'px';
      }

      if (this.getCount() == 1) {
          // Set ultimate gutter when only one column is displayed
          this._currentGutterX = this.conf.ultimateGutter;
          // As gutters are reduced, two column may fit, forcing to 1
          this._count = 1;
      } else if (this._width < (this.conf.baseWidth + (2 * this._currentGutterX))) {
          // Remove gutter when screen is to low
          this._currentGutterX = 0;
      } else {
          this._currentGutterX = this.conf.gutterX;
      }
  };

  MiniMasonry.prototype.getCount = function() {
      if (this.conf.surroundingGutter) {
          return Math.floor((this._width - this._currentGutterX) / (this.conf.baseWidth + this._currentGutterX));
      }

      return Math.floor((this._width + this._currentGutterX) / (this.conf.baseWidth + this._currentGutterX));
  };

  MiniMasonry.prototype.computeWidth = function() {
      var width;
      if (this.conf.surroundingGutter) {
          width = ((this._width - this._currentGutterX) / this._count) - this._currentGutterX;
      } else {
          width = ((this._width + this._currentGutterX) / this._count) - this._currentGutterX;
      }
      width = Number.parseFloat(width.toFixed(2));

      return width;
  };

  MiniMasonry.prototype.layout =  function() {
      if (!this._container) {
          console.error('Container not found');
          return;
      }
      this.reset();

      //Computing columns count
      if (this._count == null) {
          this._count = this.getCount();
      }
      //Computing columns width
      var colWidth = this.computeWidth();

      for (var i = 0; i < this._count; i++) {
          this._columns[i] = 0;
      }

      //Saving children real heights
      var children = this._container.children;
      for (var k = 0;k< children.length; k++) {
          // Set colWidth before retrieving element height if content is proportional
          children[k].style.width = colWidth + 'px';
          this._sizes[k] = children[k].clientHeight;
      }

      var startX;
      if (this.conf.direction == 'ltr') {
          startX = this.conf.surroundingGutter ? this._currentGutterX : 0;
      } else {
          startX = this._width - (this.conf.surroundingGutter ? this._currentGutterX : 0);
      }
      if (this._count > this._sizes.length) {
          //If more columns than children
          var occupiedSpace = (this._sizes.length * (colWidth + this._currentGutterX)) - this._currentGutterX;
          if (this.conf.wedge === false) {
              if (this.conf.direction == 'ltr') {
                  startX = ((this._width - occupiedSpace) / 2);
              } else {
                  startX = this._width - ((this._width - occupiedSpace) / 2);
              }
          } else {
              if (this.conf.direction == 'ltr') ; else {
                  startX = this._width - this._currentGutterX;
              }
          }
      }

      //Computing position of children
      for (var index = 0;index < children.length; index++) {
          var nextColumn = this.conf.minify ? this.getShortest() : this.getNextColumn(index);

          var childrenGutter = 0;
          if (this.conf.surroundingGutter || nextColumn != this._columns.length) {
              childrenGutter = this._currentGutterX;
          }
          var x;
          if (this.conf.direction == 'ltr') {
              x = startX + ((colWidth + childrenGutter) * (nextColumn));
          } else {
              x = startX - ((colWidth + childrenGutter) * (nextColumn)) - colWidth;
          }
          var y = this._columns[nextColumn];


          children[index].style.transform = 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)';

          this._columns[nextColumn] += this._sizes[index] + (this._count > 1 ? this.conf.gutterY : this.conf.ultimateGutter);//margin-bottom
      }

      this._container.style.height = (this._columns[this.getLongest()] - this._currentGutterY) + 'px';
  };

  MiniMasonry.prototype.getNextColumn = function(index) {
      return index % this._columns.length;
  };

  MiniMasonry.prototype.getShortest = function() {
      var shortest = 0;
      for (var i = 0; i < this._count; i++) {
          if (this._columns[i] < this._columns[shortest]) {
              shortest = i;
          }
      }

      return shortest;
  };

  MiniMasonry.prototype.getLongest = function() {
      var longest = 0;
      for (var i = 0; i < this._count; i++) {
          if (this._columns[i] > this._columns[longest]) {
              longest = i;
          }
      }

      return longest;
  };

  MiniMasonry.prototype.resizeThrottler = function() {
      // ignore resize events as long as an actualResizeHandler execution is in the queue
      if ( !this._resizeTimeout ) {

          this._resizeTimeout = setTimeout(function() {
              this._resizeTimeout = null;
              //IOS Safari throw random resize event on scroll, call layout only if size has changed
              if (this._container.clientWidth != this._width) {
                  this.layout();
              }
            // The actualResizeHandler will execute at a rate of 30fps
          }.bind(this), 33);
      }
  };

  MiniMasonry.prototype.destroy = function() {
      if (typeof this._removeListener == "function") {
          this._removeListener();
      }

      var children = this._container.children;
      for (var k = 0;k< children.length; k++) {
          children[k].style.removeProperty('width');
          children[k].style.removeProperty('transform');
      }
      this._container.style.removeProperty('height');
      this._container.style.removeProperty('min-width');
  };

  window.MiniMasonry = MiniMasonry;
})();